import { useState } from "react";
import { Modal} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ide.css";

const TestFailed = ({ handleClose, explanation }) => { 
  const [showModal, setShowModal] = useState(true);

  const handleCloseModal = () => {
    setShowModal(false);
    handleClose();
  };

  return (
    <Modal
      className="test-failed-modal"
      show={showModal}
      onHide={handleCloseModal}
      centered
      backdrop="static"
      keyboard={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>Error!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-inner">
          {/* <span>❌</span> */}
          {/* SVG icon for error */}
          <svg fill="#ff4545" width="800px" height="800px" viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><path d="M47.89,52H4.11A4.1,4.1,0,0,1,.44,46.05L22.33,2.27a4.1,4.1,0,0,1,7.34,0L51.56,46.05A4.1,4.1,0,0,1,47.89,52ZM26,4a.1.1,0,0,0-.1.06L4,47.84s0,0,0,.1a.09.09,0,0,0,.09.05H47.89a.09.09,0,0,0,.09-.05s0-.08,0-.1L26.1,4.06A.1.1,0,0,0,26,4Z" /><polygon points="28.85 33.55 23.16 33.55 22.84 21.29 29.16 21.29 28.85 33.55" /><rect height="6.32" rx="3" width="6.32" x="22.84" y="36.29" /></svg>
          <p>These test cases have <strong>failed</strong>! Please try again.</p>
          {/* <p>{explanation}</p> */}
        </div>
      </Modal.Body> 
    </Modal>
  );
}

export default TestFailed;
